import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { UserStore } from 'src/app/shared/services/user/user.state';

export const eventTypeFieldSettingsResolver: ResolveFn<boolean> = () => {
  const userStore = inject(UserStore);
  if (userStore.canViewEvents()) userStore.getEventTypeFieldSettings({});
  return true;
};
